"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isDocumentElement(el) {
    return [document.documentElement, document.body, window].indexOf(el) > -1;
}
exports.default = isDocumentElement;
//# sourceMappingURL=index.js.map